'use strict';

require('../common/trim');

module.exports = function module_validate_maxLength(selector, errorContainerSelector, errorClass) {
	errorContainerSelector = errorContainerSelector || '.errorContainer';
	errorClass = errorClass || 'error';

	var error = false;
	window.jQuery(selector).each(function forEachField() {
		var $this = window.jQuery(this);
		var maxLength = $this.attr('maxLength') || '';
		//you can't require an invisible text field
		if ($this.is(':visible')) {
			if (maxLength !== '' && $this.val().trim().length > maxLength) {
				//Enforcing the limit if the browser ignores the HTML attribute.
				$this.val($this.val().substring(0, maxLength));
				$this.closest(errorContainerSelector).addClass(errorClass);
				error = true;
			} else {
				$this.closest(errorContainerSelector).removeClass(errorClass);
			}
		}
	});
	return error;
};
